export default __webpack_public_path__ + "static/media/ic_shib_64.c775226b.svg";